export default __webpack_public_path__ + "static/media/404.9415a3ff.webp";